interface VideoHeroProps {
  videoSrc: string;
  imageSrc: string;
  children: React.ReactNode;
}

export default function VideoHero({ videoSrc, imageSrc, children }: VideoHeroProps) {
  return (
    <section className="video-header">
      <div className="header-overlay" />
      <div className="svg-hero-dot" />
      <img className="header-image" src={imageSrc} alt="" />
      <video className="header-video" src={videoSrc} playsInline autoPlay muted loop />
      <div className="header-fade" />
      <div className="header-content">
        {children}
      </div>
    </section>
  );
}
